import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { ClerkProvider } from '@clerk/clerk-react'
import { BrowserRouter } from 'react-router-dom'
import { store } from './store'
import App from './App'
import { ThemeProvider } from './hooks/useTheme'
import { ToastProvider } from './components/Toast'
import './i18n' // bootstrap i18next + auto-detect language
import './index.css'

const clerkKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || ''

function Root() {
  // If no Clerk key, skip ClerkProvider entirely — app works without auth
  if (!clerkKey) {
    return (
      <ThemeProvider>
        <ToastProvider>
          <BrowserRouter>
            <Provider store={store}>
              <App />
            </Provider>
          </BrowserRouter>
        </ToastProvider>
      </ThemeProvider>
    )
  }

  return (
    <ThemeProvider>
      <ToastProvider>
        <ClerkProvider publishableKey={clerkKey} afterSignOutUrl="/">
          <BrowserRouter>
            <Provider store={store}>
              <App />
            </Provider>
          </BrowserRouter>
        </ClerkProvider>
      </ToastProvider>
    </ThemeProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
)
